import { Button, Grid2 } from '@mui/material'
import React from 'react'
import Heading from '../../shared/utils/Heading'

const StudentRegistration = () => {
    return (
        <Grid2 container spacing={{xs:1,lg:2}} sx={{display:"flex",alignItems:"center"}}>
            <Grid2 children size={{ xs: 12, lg: 7 }}>
                <Heading Heading={"Join us today and take the first step toward a brighter future!"} SubHeading={"Student Registration Now Open!"} />
            </Grid2>
            <Grid2 size={{ xs: 12, lg: 3.5 }}>
                <Button variant='contained' fullWidth>Register Now</Button>
            </Grid2>

        </Grid2>
    )
}

export default StudentRegistration